"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _shortid = _interopRequireDefault(require("shortid"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _ArrowButtonDown = _interopRequireDefault(require("@berlitz/streamline-icons/lib/bold/52-Arrows-Diagrams/01-Arrows/ArrowButtonDown"));
var _Expander = require("./Expander.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var Expander = /*#__PURE__*/function (_Component) {
  _inherits(Expander, _Component);
  var _super = _createSuper(Expander);
  function Expander() {
    var _temp, _this;
    _classCallCheck(this, Expander);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.state = {
      id: _shortid.default.generate(),
      expanded: _this.props.initialState.expanded
    }, _this.handleClick = function () {
      _this.setState(function (_ref) {
        var expanded = _ref.expanded;
        return {
          expanded: !expanded
        };
      });
    }, _temp));
  }
  _createClass(Expander, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        expanded: false
      });
      if (this.props.expandedByDefault) {
        this.setState({
          expanded: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        id = _this$state.id,
        expanded = _this$state.expanded;
      var _this$props = this.props,
        title = _this$props.title,
        children = _this$props.children,
        isDisabled = _this$props.isDisabled,
        icon = _this$props.icon,
        className = _this$props.className,
        border = _this$props.border,
        shrinkTitle = _this$props.shrinkTitle;
      return /*#__PURE__*/_react.default.createElement(_Expander.Wrapper, {
        isDisabled: isDisabled,
        className: className,
        "data-key": "max-expander"
      }, isDisabled ? /*#__PURE__*/_react.default.createElement(_Expander.DisabledWrapper, {
        isDisabled: isDisabled,
        "data-key": "max-expander--isDisabled"
      }, /*#__PURE__*/_react.default.createElement(_typography.H5, {
        disableMargin: true
      }, title), children) : '', /*#__PURE__*/_react.default.createElement(_Expander.EnabledWrapper, {
        isDisabled: isDisabled,
        border: border,
        "data-key": "max-expander--enabled"
      }, /*#__PURE__*/_react.default.createElement(_Expander.ExpanderTitle, {
        "aria-controls": id,
        "aria-expanded": expanded ? 'true' : 'false',
        onClick: this.handleClick,
        icon: icon ? 1 : 0,
        "data-key": "max-expander__title",
        shrinkTitle: shrinkTitle,
        disableMargin: !shrinkTitle
      }, title, icon && /*#__PURE__*/_react.default.createElement(_Expander.ExpanderIcon, {
        expanded: expanded,
        "data-key": "max-expander__icon"
      }, /*#__PURE__*/_react.default.createElement(_ArrowButtonDown.default, {
        size: "xxs",
        color: "brand01"
      }))), /*#__PURE__*/_react.default.createElement(_Expander.ExpandedContent, {
        "aria-hidden": expanded ? 'false' : 'true',
        id: id,
        expanded: expanded,
        "data-key": "max-expander__content"
      }, children)));
    }
  }]);
  return Expander;
}(_react.Component);
Expander.defaultProps = {
  initialState: {
    expanded: true
  },
  expandedByDefault: false,
  border: true,
  icon: false,
  isDisabled: null,
  shrinkTitle: false
};
var _default = Expander;
exports.default = _default;